import { Type } from 'typebox';

/* Space kinds and booking types are shared by the API, the twin and the apps (GLOSSARY.md). */
export const SPACE_KINDS = [
  'meeting_room',
  'desk',
  'workspace_area',
  'parking_spot',
  'lobby',
  'point_of_interest',
  'unit',
] as const;
export type SpaceKind = (typeof SPACE_KINDS)[number];
export const SpaceKind = Type.Enum(SPACE_KINDS);

export const BOOKING_TYPES = ['space', 'desk', 'event', 'parking'] as const;
export type BookingType = (typeof BOOKING_TYPES)[number];
export const BookingType = Type.Enum(BOOKING_TYPES);

export const BOOKING_STATUSES = ['pending', 'approved', 'cancelled', 'sync_error'] as const;
export type BookingStatus = (typeof BOOKING_STATUSES)[number];
export const BookingStatus = Type.Enum(BOOKING_STATUSES);
